import {
  FULFILLMENT_ERROR,
  GET_FULFILLMENT_CONTACT,
  EDIT_FULFILLMENT_SUCCESS,
  GET_FULFILLMENT,
} from "../constants/fulfillmentConstants";
import Axios from "axios";
import { setAlert } from "./alertAction";
import { API_ROOT } from "../components/utils/api-config";
import { history } from "../Root";

let token = "Bearer " + localStorage.getItem("token");
const config = {
  headers: {
    Authorization: token,
  },
};
export const requestFulfillment = (id) => (dispatch) => {
  Axios.get(`${API_ROOT}/orders/${id}/`, config)
    .then((response) =>
      dispatch({ type: GET_FULFILLMENT, payload: response.data })
    )
    .catch((error) => {
      dispatch({ type: FULFILLMENT_ERROR, payload: error }),
        dispatch(setAlert("Order does not exist", "danger"));
      history.push(`/logistics`);
    });
};

export const editFulfillment = (fulfillment) => (dispatch) => {
  dispatch({ type: EDIT_FULFILLMENT_SUCCESS, payload: fulfillment });
  dispatch(setAlert(fulfillment, "success"));
};

export const requestFulfillmentContact = (id, order_id) => (dispatch) => {
  Axios.get(`${API_ROOT}/fulfillments/contact?id=${id}&order_id=${order_id}`)
    .then((response) =>
      dispatch({ type: GET_FULFILLMENT_CONTACT, payload: response.data })
    )
    .catch((error) => {
      dispatch({ type: FULFILLMENT_ERROR, payload: error }),
        dispatch(setAlert("Cannot find your info", "danger"));
    });
};
